// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../../../provider/Context.bs.js";
import * as Atom_Cta from "../../atom/Atom_Cta.bs.js";
import * as Atom_Row from "../../atom/Atom_Row.bs.js";
import * as Atom_Grid from "../../atom/Atom_Grid.bs.js";
import * as Atom_Text from "../../atom/Atom_Text.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Atom_Column from "../../atom/Atom_Column.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Type_String from "../../../type/Type_String.bs.js";
import * as Atom_Text_Ds from "../../atom/Atom_Text_Ds.bs.js";
import * as Atom_Image_Ds from "../../atom/Atom_Image_Ds.bs.js";
import * as Organism_Slider from "./Organism_Slider.bs.js";
import * as Organism_Teaser from "../teaser/Organism_Teaser.bs.js";
import * as Molecule_Download from "../../molecule/Molecule_Download.bs.js";
import * as Organism_Slider_Ds from "./Organism_Slider_Ds.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../../particle/Particle_Spacer_Ds.bs.js";
import * as Particle_Screen_Constants from "../../particle/Particle_Screen_Constants.bs.js";
import * as Organism_Teaser_Css_Identifier from "../teaser/Organism_Teaser_Css_Identifier.bs.js";

var match = Atom_Image_Ds.view(Atom_Image_Ds.make(/* StandardTeaser */15));

var size = match.size;

var match$1 = Particle_Screen_Ds.getValueByScreenSize({
      NAME: "XS",
      VAL: undefined
    }, size);

var match$2;

if (match$1 !== undefined && typeof match$1 === "object" && match$1.NAME === "Custom") {
  var match$3 = match$1.VAL;
  match$2 = [
    match$3[0],
    match$3[1]
  ];
} else {
  match$2 = [
    0,
    0
  ];
}

var xsHeight = match$2[1];

var xsWidth = match$2[0];

var match$4 = Particle_Screen_Ds.getValueByScreenSize({
      NAME: "M",
      VAL: undefined
    }, size);

var match$5;

if (match$4 !== undefined && typeof match$4 === "object" && match$4.NAME === "Custom") {
  var match$6 = match$4.VAL;
  match$5 = [
    match$6[0],
    match$6[1]
  ];
} else {
  match$5 = [
    0,
    0
  ];
}

var mHeight = match$5[1];

var mWidth = match$5[0];

var gridRules = Particle_Screen_Ds.make(undefined, undefined, undefined, [CssJs.gridTemplateColumns([{
              NAME: "repeat",
              VAL: [
                "autoFit",
                {
                  NAME: "minmax",
                  VAL: [
                    CssJs.px(mWidth),
                    CssJs.maxContent
                  ]
                }
              ]
            }])], undefined, [CssJs.gridTemplateColumns([{
              NAME: "repeat",
              VAL: [
                "autoFit",
                {
                  NAME: "minmax",
                  VAL: [
                    CssJs.px(xsWidth),
                    CssJs.maxContent
                  ]
                }
              ]
            }])]);

var gridGap = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M");

var wrapperRules = Particle_Screen_Ds.make(undefined, undefined, undefined, [Organism_Teaser_Css_Identifier.Selectors.teaserImageSelector([CssJs.minHeight(CssJs.px(mHeight))])], undefined, [
      Organism_Teaser_Css_Identifier.Selectors.teaserItemsSelector([CssJs.width(CssJs.pct(100))]),
      Organism_Teaser_Css_Identifier.Selectors.teaserImageSelector([
            CssJs.width(CssJs.pct(100)),
            CssJs.height(CssJs.pct(100)),
            CssJs.minHeight(CssJs.px(xsHeight))
          ])
    ]);

function Organism_Video_Content_Presse$TemplateVideoGrid(Props) {
  var children = Props.children;
  var id = Props.id;
  var display = Props.display;
  return React.createElement(Atom_Column.make, {
              children: React.createElement(Atom_Grid.make, {
                    blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeTop("M")),
                    children: children,
                    gap: gridGap,
                    rules: gridRules
                  }),
              display: display,
              id: id,
              innerSpace: Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS"),
              rules: wrapperRules,
              width: Particle_Screen_Constants.oneHundredPctWidth
            });
}

var TemplateVideoGrid = {
  size: size,
  xsWidth: xsWidth,
  xsHeight: xsHeight,
  mWidth: mWidth,
  mHeight: mHeight,
  gridRules: gridRules,
  gridGap: gridGap,
  wrapperRules: wrapperRules,
  make: Organism_Video_Content_Presse$TemplateVideoGrid
};

function updateImageHeight(image, screenSize) {
  return Belt_Option.map(Organism_Slider_Ds.getWidthAndHeight(image, screenSize), (function (param) {
                return param.height;
              }));
}

var heightComputation = /* Custom */{
  _0: (function (param) {
      return updateImageHeight(/* StandardTeaser */15, param);
    })
};

function selectItems(__x) {
  return __x.querySelectorAll(Molecule_Download.downloadItemIdentifier);
}

var itemSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M");

function Organism_Video_Content_Presse$TemplateSLider(Props) {
  var children = Props.children;
  var display = Props.display;
  var sliderRef = React.useRef(null);
  return React.createElement(Atom_Column.make, {
              children: React.createElement(Organism_Slider.make, {
                    children: children,
                    heightComputation: heightComputation,
                    itemSpace: itemSpace,
                    selectItems: selectItems,
                    sliderRef: sliderRef,
                    verticalPadding: "M"
                  }),
              display: display
            });
}

var TemplateSLider = {
  updateImageHeight: updateImageHeight,
  heightComputation: heightComputation,
  selectItems: selectItems,
  itemSpace: itemSpace,
  make: Organism_Video_Content_Presse$TemplateSLider
};

function Organism_Video_Content_Presse(Props) {
  var title = Props.title;
  var id = Props.id;
  var items = Props.items;
  var href = Props.href;
  var titleId = id + "_title";
  var match;
  match = items.TAG === /* Download */0 ? [
      Belt_Array.mapWithIndex(items._0, (function (i, param) {
              return React.createElement(Molecule_Download.make, {
                          title: param.title,
                          subtitle: param.subtitle,
                          href: param.href,
                          imageSrc: param.imageSrc,
                          id: param.id,
                          key: String(i)
                        });
            })),
      Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "none"),
      Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flex")
    ] : [
      Belt_Array.map(items._0, (function (teaser) {
              return React.createElement(Organism_Teaser.make, {
                          teaser: teaser,
                          key: Curry._1(Type_String.Teaser.Key.toString, teaser.key)
                        });
            })),
      Particle_Screen_Ds.make(undefined, undefined, undefined, "flex", undefined, "none"),
      Particle_Screen_Ds.make(undefined, undefined, undefined, "none", undefined, "flex")
    ];
  var items$1 = match[0];
  var match$1 = Context.I18n.getState(undefined);
  var match$2 = match$1.labels.common;
  var downloadAll = match$2.downloadAll;
  return React.createElement(Atom_Column.make, {
              children: null,
              justifyContent: Particle_Screen_Constants.justifyContentFlexStart,
              width: Particle_Screen_Constants.oneHundredPctWidth
            }, React.createElement(Atom_Row.make, {
                  alignItems: Particle_Screen_Constants.alignItemsFlexEnd,
                  children: null,
                  justifyContent: Particle_Screen_Constants.justifyContentSpaceBetween,
                  width: Particle_Screen_Constants.oneHundredPctWidth
                }, React.createElement(Atom_Text.make, {
                      children: title,
                      id: titleId,
                      kind: "h2",
                      style: Atom_Text_Ds.Slider.make("Title")
                    }), Belt_Option.mapWithDefault(href, null, (function (href) {
                        return React.createElement(Atom_Cta.Link.make, {
                                    href: href,
                                    label: downloadAll,
                                    style: {
                                      TAG: /* Slider */19,
                                      _0: /* DownloadAll */2
                                    }
                                  });
                      }))), React.createElement(Organism_Video_Content_Presse$TemplateSLider, {
                  children: items$1,
                  display: match[2]
                }), React.createElement(Organism_Video_Content_Presse$TemplateVideoGrid, {
                  children: items$1,
                  id: id,
                  display: match[1]
                }));
}

var width = Particle_Screen_Constants.oneHundredPctWidth;

var make = Organism_Video_Content_Presse;

export {
  width ,
  TemplateVideoGrid ,
  TemplateSLider ,
  make ,
}
/* match Not a pure module */
